/*
 *
 * Filter constants
 *
 */

export const DEFAULT_ACTION = "src/Filter/DEFAULT_ACTION";
export const SET_OPENCATEGORY = "src/Filter/SET_OPENCATEGORY";
export const SET_SELECTEDCATEGORY = "src/Filter/SET_SELECTEDCATEGORY";
